import styled from "styled-components";

/**
 * Inline flex row holding the two independent controls (Follow + Message) in the
 * `full` variant. The controls themselves are the shared Button atom; this only
 * owns their spacing so alignment stays consistent everywhere it's dropped in.
 * `$gap` (ISP-9999 #965) lets a cramped surface (the header global-search
 * dropdown) tighten the icon-to-icon gap so it stops crowding out the
 * username; every other caller keeps the 8px default byte-identical.
 */
export const Row = styled.div`
  display: inline-flex;
  /* $stack (QA-1014): render the two controls VERTICALLY stacked (notification
     follow rows want Follow above Message on the right); default stays a row so
     every other caller is byte-identical. */
  flex-direction: ${({ $stack }) => ($stack ? "column" : "row")};
  align-items: ${({ $stack }) => ($stack ? "stretch" : "center")};
  gap: ${({ $gap }) => ($gap != null ? $gap : 8)}px;
  flex-shrink: 0;
`;
